import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { CustomToggle } from './customToggle';

const ChildPermissionAccord = ({
  menu,
  handleCheckboxChange,
  openAccordion,
  setOpenAccordion,
  index,
}) => {
  return (
    <Accordion defaultActiveKey={['0']} className="subAccordion">
      {menu?.screenPermissions.map((screen, idx) => (
        <Card
          key={screen.permissionId}
          style={{ boxShadow: 'none', minHeight: '0', margin: '0', borderRadius: '0' }}
        >
          <Card.Header
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              border: 'none',
              background: '#fff',
              borderBottom: '1px rgb(0,0,0,.125)',
              margin: '0rem 0 .1rem 0',
            }}
          >
            <div>
              <input
                type="checkbox"
                name=""
                id=""
                style={{ marginRight: '5px' }}
                checked={screen.canView}
                onChange={() =>
                  handleCheckboxChange('screenPermissions', screen, screen.permissionId)
                }
              />
              {screen.permissionDisplayName}
            </div>
            <CustomToggle
              eventKey={`${index}-${idx}`}
              isOpen={openAccordion === `${index}-${idx}`}
            />
          </Card.Header>
          <Accordion.Collapse eventKey={`${index}-${idx}`}>
            <Card.Body
              style={{
                background: '#fff',
                padding: '15px',
                marginBottom: '1rem',
              }}
            >
              <div className="checkboxes" style={{ margin: '0' }}>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Fields</th>
                      <th>View</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {screen.fieldPermissions.map((field) => (
                      <tr key={field.permissionId}>
                        <td>
                          <label className="label" htmlFor={field.permissionValue}>
                            {field.permissionDisplayName}
                          </label>
                        </td>
                        <td>
                          <input
                            className="checkbox-name"
                            type="checkbox"
                            id={`canView-${field.permissionId}`}
                            checked={field.canView}
                            onChange={() =>
                              handleCheckboxChange('canView', field, field.permissionId)
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox-name"
                            type="checkbox"
                            id={`canEdit-${field.permissionId}`}
                            checked={field.canEdit}
                            onChange={() =>
                              handleCheckboxChange('canEdit', field, field.permissionId)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  );
};
export default ChildPermissionAccord;
